<template>
	<AmeliproErrorTemplate
		is-maintenance-message
		error-type="maintenance"
		:custom-content-title="pageInfo.title"
		:custom-content-text="pageInfo.message"
		no-button
	/>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { IndexedObject } from '@cnamts/vue-dot/src/types';

	@Component
	export default class Maintenance extends Vue {
		get pageInfo(): IndexedObject {
			// Use env var and default text
			return {
				title: window.MAINTENANCE_TITLE || 'Maintenance en cours',
				message: window.MAINTENANCE_MESSAGE || 'L’application n’est pas disponible pour le moment, veuillez nous excuser pour la gêne occasionnée.'
			};
		}
	}
</script>
